import { Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import { VendorLocation } from 'src/app/shared/models/vendor-location.model';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import * as _ from 'lodash';

@Component({
  selector: 'hg-vendor-location',
  templateUrl: './vendor-location.component.html',
  styleUrls: ['./vendor-location.component.scss']
})
export class VendorLocationComponent implements OnInit {

  @Input()
  userLocations: string[];

  @Input()
  carrierId: string;

  @Input()
  actionType = '';

  @Input()
  carrierUser: any;

  @Output()
  locationsObjEmitter: EventEmitter<string[]> = new EventEmitter<string[]>();

  allLocations: string[] = ['All'];
  segmentLocations: string[] = [];

  private _userVisibility: string[];
  get userVisibility(): string[] {
    return this._userVisibility;
  }
  set userVisibility(val: string[]) {
    if (val.length === 1 && val[0] === 'All') {
      this.vendorLocations = this.vendorLocations.map(m => { m.checked = true; return m; });
      this.segmentLocations = this.vendorLocations.map(m => m.code);
    }
    this._userVisibility = val;
    this.emitLocationChange();
  }

  loading: boolean = true;
  vendorLocations: VendorLocation[];

  currentUserRole = '';
  carrierUserRole = '';
  adminLocations = [];
  adminHasAll = true;

  constructor(private carrierService: CarrierService,
    private currentUserService: CurrentUserService,
    private errorHandlerService: ErrorHandlerService
    ) { }

  ngOnInit() {
    this.adminHasAll = true;
    this.currentUserRole = _.get(this.currentUserService.user, 'role.code');
    this.carrierUserRole = _.get(this.carrierUser, 'role.code');

    const user = this.currentUserService.user;
    let organization = _.get(user, 'extended.organizations', []).find(org => org.organizationCode === this.currentUserService.user.organizationCode);
    this.adminLocations = _.get(organization, 'locations', []);
    if (!this.adminLocations.length) {
      this.adminLocations = _.get(user, 'extended.locations', []);
    }

    this.carrierService.getVendorLocations(this.carrierId).subscribe((locations: VendorLocation[]) => {
      this.vendorLocations = locations;
      if (this.isCarrierAdmin(this.currentUserRole) && !this.isCarrierAdmin(this.carrierUserRole)) {
        this.adminHasAll = !!(this.adminLocations.find(e => e === 'All'));
        if (!this.adminHasAll) {
          this.vendorLocations = locations.filter((e) => this.adminLocations.includes(e.code));
        }
      }
      this.loading = false;
      this.assignUserLocations();
    }, err => {
      this.loading = false;
      console.log(err);
      this.errorHandlerService.handleError(err.error.error)
    });
  }

  isCarrierAdmin(role: string) {
    if(['HC_CARRIER_ADMIN', 'HC_CARRIER_BROKER_ADMIN'].includes(role)) {
      return true;
    }
    return false;
  }

  isUpdateDisabled() {
    if (this.actionType === 'create' || !this.isCarrierAdmin(this.currentUserRole)) {
      return false;
    }
    const carrierUserID = _.get(this.carrierUser, '_id');
    const currentUserID = _.get(this.currentUserService, 'user._id');
    if (carrierUserID === currentUserID) {
      return true;
    }
    if (this.isCarrierAdmin(this.currentUserRole) && this.isCarrierAdmin(this.carrierUserRole)) {
      return true;
    }
    return false;
  }

  assignUserLocations(){
    if (typeof(this.userLocations) === 'string'){
      this.userLocations = [this.userLocations];
    }
    if (this.userLocations && this.userLocations.length) {
      if (this.userLocations.length === 1 && this.userLocations[0] === 'All') {
        this.userVisibility = this.allLocations;
      } else if (this.userLocations.length > 0) {
        this.vendorLocations = this.vendorLocations.map(m => { m.checked = this.userLocations.includes(m.code); return m; });
        this.segmentLocations = this.vendorLocations.filter(f => f.checked).map(m => m.code);
        this.userVisibility = this.segmentLocations;
      }
    } else {
      if (this.vendorLocations.length) {
        this.userVisibility = [];
      }
    }
  }

  emitLocationChange() {
    this.locationsObjEmitter.emit(this.userVisibility);
  }

  addLocation(location: VendorLocation) {
    location.checked = !location.checked;
    this.segmentLocations = this.vendorLocations.filter(f => f.checked).map(m => m.code);
    if (this.adminHasAll && this.segmentLocations.length === this.vendorLocations.length) {
      this.userVisibility = this.allLocations;
    } else {
      this.userVisibility = this.segmentLocations;
    }
  }


}
